import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import "./../../node_modules/swiper/swiper-bundle";
import './Team.css';

// Reusable component for displaying member details
const Member = ({ name, title, image }) => (
  <div className="member">
    <img src={image} alt={name} className="member-image" />
    <h3 className="member-name">{name}</h3>
    <p className="member-title">{title}</p>
  </div>
);

const AdvisoryBoard = () => {
  const members = [
    { name: 'Mohammad Kashif Siddiqee', title: 'Strategic Planning & New Initiatives', image: 'https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/03/profile-img.png' },
    { name: 'Talha Khan', title: 'Business Planning', image: 'https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/03/profile-img.png' },
    { name: 'Harry Asif Sarwar', title: 'New Market Development', image: 'https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/03/profile-img.png' },
    { name: 'Mufti Irshad Ahmad Ajjaz', title: 'Shariah Advisor', image: 'https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/03/profile-img.png' },
  ];

  return (
    <div className="advisory-board">
      <h2>Advisory Board</h2>
      <Swiper spaceBetween={30} slidesPerView={2} navigation>
        {members.map((member, index) => (
          <SwiperSlide key={index}>
            <Member {...member} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

const CoreTeam = () => {
  const members = [
    { name: 'Adil Zaheer', title: 'CTO', image: '/img/adil.jpeg' },
    { name: 'Qasim Ijaz', title: 'Team Lead', image: '/img/qasim.png' },
    { name: 'Muhammad Usama', title: 'Team Lead', image: '/img/osama@2x.png' },
    { name: 'Nimra Riaz', title: 'Digital Marketing', image: '/img/nimra.png' },
    { name: 'Zainab Iman', title: 'Digital Marketing', image: '/img/ZAINAB.jpg' },
    { name: 'Hamid Ali', title: 'PMO', image: '/img/Hamid.jpg' },
    { name: 'Iftikhar Ahmad', title: 'Regional Head DACH', image: '/img/Kashif.png' },
    { name: 'Muhammad Hamza', title: 'Software Engineer', image: '/img/hamza.jpg' },
    { name: 'Shahbaz Ahmad', title: 'Software Engineer', image: '/img/Shahbaz.png' },
    { name: 'Muhammad Naveed', title: 'Software Engineer', image: '/img/naveed@2x.png' },
    { name: 'Hashir Anees', title: 'UIUX Design', image: '/img/hashir.png' }, 
    { name: 'Arwa Rani', title: 'QA & Management', image: 'https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/03/profile-img.png'},
    { name: 'Laila', title: 'QA & Management', image: 'https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/03/profile-img.png'},
  ];

  return (
    <div className="core-team">
      <h2>Core Team</h2>
      <Swiper spaceBetween={4} slidesPerView={5} navigation>
        {members.map((member, index) => (
          <SwiperSlide key={index}>
            <Member {...member} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

const Team = () => (
  <div className="team">
    <AdvisoryBoard />
    {/* <CoreTeam /> */}
  </div>
);

export default Team;
